import { render, staticRenderFns } from "./DebtorsReport.vue?vue&type=template&id=22a99391"
import script from "./DebtorsReport.vue?vue&type=script&lang=js"
export * from "./DebtorsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports